import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "connected-services-view full-view" }
const _hoisted_2 = {
  key: 1,
  class: "token-text-medium provider-option-label"
}
const _hoisted_3 = {
  key: 1,
  class: "token-text-h4 provider-title"
}
const _hoisted_4 = { class: "token-text-medium" }
const _hoisted_5 = { class: "ml-auto d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MPHDefault = _resolveComponent("MPHDefault")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_MPFDefault = _resolveComponent("MPFDefault")!
  const _component_CustomTextInput = _resolveComponent("CustomTextInput")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ModalTunnel = _resolveComponent("ModalTunnel")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalTunnel, {
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModal) = $event)),
      closeOnExternalClick: false,
      nbPages: _ctx.nbTunnelPages,
      displayNavigation: false,
      ref: "refTunnel"
    }, {
      [`header-${_ctx.pages.PROVIDER.pageNum}`]: _withCtx(() => [
        _createVNode(_component_MPHDefault, {
          header: _ctx.header,
          closeButton: true,
          onClose: _ctx.closeModal
        }, null, 8, ["header", "onClose"])
      ]),
      [`content-${_ctx.pages.PROVIDER.pageNum}`]: _withCtx(() => [
        _createVNode(_component_v_col, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "ma-0 token-text-h5 mx-auto fit-content" }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" Please select a provider ")
              ])),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "ma-0 mt-4 provider-grid" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providers, (provider) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: provider.id,
                    class: _normalizeClass(["pa-0 provider-option", { selected: _ctx.selectedProviderId === provider.id }]),
                    onClick: ($event: any) => (_ctx.selectProvider(provider))
                  }, {
                    default: _withCtx(() => [
                      (provider.logo)
                        ? (_openBlock(), _createBlock(_component_Logo, {
                            key: 0,
                            logo: provider.logo,
                            class: "provider-logo"
                          }, null, 8, ["logo"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(provider.name), 1))
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      [`footer-${_ctx.pages.PROVIDER.pageNum}`]: _withCtx(() => [
        _createVNode(_component_MPFDefault, {
          previousLabel: _ctx.pages.PROVIDER.previousLabel,
          nextLabel: _ctx.pages.PROVIDER.nextLabel,
          disableNextButton: _ctx.disableNextButton,
          onPrevious: _ctx.closeModal,
          onNext: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.API_KEY)))
        }, null, 8, ["previousLabel", "nextLabel", "disableNextButton", "onPrevious"])
      ]),
      [`header-${_ctx.pages.API_KEY.pageNum}`]: _withCtx(() => [
        _createVNode(_component_MPHDefault, {
          header: _ctx.header,
          closeButton: true,
          onClose: _ctx.closeModal
        }, null, 8, ["header", "onClose"])
      ]),
      [`content-${_ctx.pages.API_KEY.pageNum}`]: _withCtx(() => [
        _createVNode(_component_v_col, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "ma-0 token-text-regular" }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Connection name ")
              ])),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "ma-0 mt-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomTextInput, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                  placeholder: "Connection name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProviderRequirements, (field) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: field }, [
                _createVNode(_component_v_row, { class: "ma-0 mt-4 token-text-regular field-label" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fieldLabel(field)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_row, { class: "ma-0 mt-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CustomTextInput, {
                      modelValue: _ctx.form[field],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form[field]) = $event),
                      placeholder: _ctx.fieldLabel(field),
                      type: "password"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                  ]),
                  _: 2
                }, 1024)
              ], 64))
            }), 128))
          ]),
          _: 1
        })
      ]),
      [`footer-${_ctx.pages.API_KEY.pageNum}`]: _withCtx(() => [
        _createVNode(_component_MPFDefault, {
          previousLabel: _ctx.pages.API_KEY.previousLabel,
          hidePreviousButton: _ctx.editingAccountId,
          nextLabel: _ctx.pages.API_KEY.nextLabel,
          disableNextButton: _ctx.disableNextButton,
          onPrevious: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.PROVIDER))),
          onNext: _cache[3] || (_cache[3] = ($event: any) => {
            _ctx.goToPage(_ctx.pageKeys.VALIDATION);
            _ctx.saveAccount();
          })
        }, null, 8, ["previousLabel", "hidePreviousButton", "nextLabel", "disableNextButton"])
      ]),
      [`header-${_ctx.pages.VALIDATION.pageNum}`]: _withCtx(() => [
        _createVNode(_component_MPHDefault, {
          header: _ctx.header,
          closeButton: false
        }, null, 8, ["header"])
      ]),
      [`content-${_ctx.pages.VALIDATION.pageNum}`]: _withCtx(() => [
        _createVNode(_component_v_col, { class: "pa-4" }, {
          default: _withCtx(() => [
            (_ctx.selectedProvider.logo)
              ? (_openBlock(), _createBlock(_component_Logo, {
                  key: 0,
                  logo: _ctx.selectedProvider.logo
                }, null, 8, ["logo"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Spinner, { class: "ma-auto mt-4" }),
            _createVNode(_component_v_row, { class: "ma-0 mt-2" }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "mx-auto" }, "Validating account, please wait...", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 2
    }, 1032, ["visible", "nbPages"]),
    _createVNode(_component_v_col, { class: "pa-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "ma-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0 token-text-h4" }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode(" Connected services ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "ma-0 mt-8" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "ma-0 token-text-h5" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode(" Manage connected services ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "ma-0 token-text-regular token-text-color-secondary mt-1" }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" You can connect multiple accounts per provider. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "pa-0 ml-auto fit-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomButton, {
                  text: "Add account",
                  icon: "add",
                  level: _ctx.$enums.ButtonLevels.Secondary,
                  disabled: !_ctx.providers.length,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal()))
                }, null, 8, ["level", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "ma-0 mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_Divider)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "ma-0 mt-4 token-text-regular token-text-color-secondary"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode(" Loading connected accounts... ")
              ])),
              _: 1
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.providers, (provider) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: provider.id
              }, [
                _createVNode(_component_v_row, { class: "ma-0 mt-10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "pa-0 pb-2 d-flex" }, {
                      default: _withCtx(() => [
                        (provider.logo)
                          ? (_openBlock(), _createBlock(_component_Logo, {
                              key: 0,
                              logo: provider.logo,
                              class: "mr-3 ml-0"
                            }, null, 8, ["logo"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(provider.name), 1)),
                        _createVNode(_component_CustomButton, {
                          class: "ml-auto px-2",
                          level: _ctx.$enums.ButtonLevels.Secondary,
                          icon: "add",
                          onClick: ($event: any) => (_ctx.openModal(provider))
                        }, null, 8, ["level", "onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsByProvider[provider.id], (account) => {
                  return (_openBlock(), _createBlock(_component_v_row, {
                    class: "ma-0 mt-2 account-row",
                    key: account.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "pa-3 bar" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(account.attributes.name), 1),
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_CustomButton, {
                                  class: "mr-2",
                                  level: _ctx.$enums.ButtonLevels.SmallIcon,
                                  icon: "edit",
                                  onClick: ($event: any) => (_ctx.openModal(provider, account.id))
                                }, null, 8, ["level", "onClick"]),
                                _createVNode(_component_CustomButton, {
                                  level: _ctx.$enums.ButtonLevels.SmallIcon,
                                  icon: "trash",
                                  onClick: ($event: any) => (_ctx.deleteAccount(account.id))
                                }, null, 8, ["level", "onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (!_ctx.accountsByProvider[provider.id].length)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      class: "ma-0 mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "pa-0 token-text-regular token-text-color-secondary" }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode(" No account connected yet. ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
      ]),
      _: 1
    })
  ]))
}